import React, { Component } from "react";
import { FormattedMessage, defineMessages } from "react-intl";
import Form from "assets/scripts/components/common/form/Form/Form";
import isEmpty from "assets/scripts/utils/isEmpty";
import validEmail from "assets/scripts/utils/validEmail";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
const messages = defineMessages({
    submit: {
        id: "forms.passwordForgotInitial.submit",
        defaultMessage: "Send"
    },
    emailLabel: {
        id: "forms.passwordForgotInitial.email.label",
        defaultMessage: "Email address"
    },
    emailHelp: {
        id: "forms.passwordForgotInitial.email.help",
        defaultMessage: "Must be a valid email address"
    }
});
function getErrors(value) {
    return {
        email: isEmpty(value.email) || !validEmail(value.email) ? REQUIRED : null
    };
}
export default class PasswordForgotInitialForm extends Component {
    constructor(props, context) {
        super(props, context);
        this._handleEmailChange = (email) => this.setState({ email });
        this.state = {
            email: ""
        };
        this._handleSubmit = this._handleSubmit.bind(this);
    }
    render() {
        const { props, state } = this;
        const errors = getErrors(state);
        const isValid = Object.values(errors).every(it => it == null);
        const { globalError, backendErrors } = mapBackendErrors(props.fieldErrors);
        return (<Form isBusy={props.isLoading} isValid={isValid} onSubmit={this._handleSubmit} submitLabel={messages.submit} hideRequiredMessage error={globalError}>
				<fieldset className="fieldset">
					<legend>
						<span className="u-isVisuallyHidden">
							<FormattedMessage id="forms.passwordForgotInitial.legend" defaultMessage="Your Email"/>
						</span>
					</legend>

					<TextFormGroup name="email" type="email" label={messages.emailLabel} help={messages.emailHelp} value={state.email} onChange={this._handleEmailChange} error={errors.email} backendError={backendErrors.emailAddress} required inputProps={{
            autoComplete: "email"
        }}/>
				</fieldset>

				{(process.env.CLIENT !== "CapOne" || state.email) && (<div className="text">
						<FormattedMessage id="passwordForgotInitial.consent" defaultMessage="By clicking Send, you consent to receive a one-time password reset email to the email address you are entering." values={{
            email: state.email ?? ""
        }} tagName="p"/>
					</div>)}
			</Form>);
    }
    _handleSubmit() {
        this.props.forgotPassword(this.state.email);
        this.props.closeModal({
            modalId: "forgotPassword",
            triggerId: "forgotPassword"
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/PasswordForgotInitialForm.tsx